import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../../../../../common/Buttons/Button";
import Typography from "../../../../../../../../common/Typography";
import Input from "../../../../../../../../common/TextFields/Input";
import {
  getSubscribedMembershipsRewards,
  sendAndVerifyOtpForMembPurchase,
  setShortlinkData,
} from "../../../../../../../../../redux/actions/shortlinkActions";

const EnterPhone = ({
  state,
  setState,
  membershipId,
  isSubsMembExpired,
  membershipEntityId,
  setPurchasedInTestStatus,
}) => {
  const dispatch = useDispatch();
  const initData = useSelector((state) => state?.shortLink?.initData);

  const [error, setError] = useState("");
  const [isSendingOTP, toggleSendingOTP] = useState(false);

  const callingCode =
    initData?.calling_code ?? initData?.customer?.calling_code ?? "";
  const membPromoId = initData?.membership_promotion_id ?? "";
  const isTestShortlink = initData.type === "membership_test";

  const handleChange = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSendOTP = (e) => {
    e.preventDefault();

    if (state.customer_mobile.length !== 10) {
      setError("Please enter 10 digit customer mobile");
      return;
    }

    if (isTestShortlink) {
      setPurchasedInTestStatus(true);
      setState((prev) => ({
        ...prev,
        step: "payment-success",
      }));
      return;
    }

    if (!membPromoId || !membershipId) return;

    const sendOtpData = {
      customer_mobile: state.customer_mobile,
      membership_setting_id: membershipId,
      membership_promotion_id: membPromoId,
    };

    toggleSendingOTP(true);
    sendAndVerifyOtpForMembPurchase(sendOtpData, true)
      .then((payload) => {
        setError("");
        const customerId = payload?.customer_id;
        const isAlreadySubscribed = payload?.subscribed && !isSubsMembExpired;
        if (isAlreadySubscribed) {
          if (!customerId || !membershipEntityId) return;

          const query = {
            customerId,
            entityId: membershipEntityId,
          };

          dispatch(getSubscribedMembershipsRewards(query))
            .then(() => {
              dispatch(
                setShortlinkData({
                  ...initData,
                  customer_id: customerId,
                  isFilterSubsMembs: false,
                })
              );
              setState((prev) => ({
                ...prev,
                step: "already-subscribed",
              }));
            })
            .catch((errMsg) => setError(errMsg));
        } else {
          setState((prev) => ({
            ...prev,
            step: "verify-otp",
          }));
        }
      })
      .catch((errMsg) => setError(errMsg))
      .finally(() => toggleSendingOTP(false));
  };

  return (
    <form onSubmit={handleSendOTP} className="enter-phone-content">
      <img
        width={40}
        height={40}
        alt="telephone"
        src="/assets/images/membership/shortlink/telephone.svg"
      />
      <Typography
        size="display-xl"
        weight="medium"
        customClass="mobile-number-label"
      >
        Enter your mobile number
      </Typography>
      <Input
        type="number"
        errorOnly={error}
        name="customer_mobile"
        handleChange={handleChange}
        value={state.customer_mobile}
        placeholder="Your Mobile Number"
        customClass="phone-number-input"
        leftIcon={<Typography>{callingCode}</Typography>}
      />
      <Button
        type="submit"
        fullWidth={true}
        disabled={isSendingOTP}
        customClass="action-btn"
        isSubmitting={isSendingOTP}
        handleClick={handleSendOTP}
        text={isTestShortlink ? "Buy Now" : "Send OTP"}
      />
    </form>
  );
};

export default EnterPhone;
